  function delayScrollAnime() {
    var timeStep = 0.2; // 1要素ごとの追加ディレイ秒
    $(".js-scroll").each(function () {
      var parent = this;
      // すでに一度発火したらスキップ
      if ($(parent).hasClass("is-animated")) return;

      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      // トリガー閾値（統一: 15%）
      var triggerOffset = windowHeight * 0.15;

      if (scroll >= elemPos - windowHeight + triggerOffset) {
        var value = timeStep;
        var childs = $(this).children();
        $(this).css("opacity", 1); // 親は見える状態へ
        $(childs).each(function () {
          $(this).css("animation-delay", value + "s");
          $(this).addClass("fadeUp");
          value += timeStep;
        });
        $(parent).addClass("is-animated"); // 一度だけ
      }
    });
  }

  // スクロール・ロード時（間引き）
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        delayScrollAnime();
        ticking = false;
      });
    }
  }
  $(window).on("scroll", onScroll);
  $(window).on("load", function () {
    delayScrollAnime();
  });

  // ========== 2) シンプルなフェード（show-fade） ==========
  function simpleFade() {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var triggerOffset = windowHeight * 0.15; // 統一: 15%

    $(".fade").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + triggerOffset) {
        $(this).addClass("show-fade");
        // 繰り返し不要なら属性やフラグを付けて二度目以降の処理を避けてもOK
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(simpleFade);
  });
  $(window).on("load", simpleFade);

  // ========== 3) 画像イン（show-img）SP/PC閾値切り替え ==========
  function imgIn() {
    var winW = $(window).width();
    var showH = winW <= 767 ? 100 : 300; // SP/PCで閾値を変更
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    $(".img-in img").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + showH) {
        $(this).addClass("show-img");
      } else {
        // 一度だけなら外さない
        // $(this).removeClass("show-img");
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(imgIn);
  });
  $(window).on("load resize", imgIn);

  // ========== 4) inViewトリガー（個別解除で統一） ==========
  inView.offset(0.15 * window.innerHeight); // 15%入ったら

  inView('[data-inview]')
    .on('enter', el => {
      el.classList.add('is-inview');
      // 個別に二度目以降のトリガーを避ける
      el.removeAttribute('data-inview');
    })
    .on('exit', el => {
      // 繰り返し表示したい場合は必要に応じて解除
      // el.classList.remove('is-inview');
    });

  // data-delay属性で遅延指定（ms）
  document.querySelectorAll('.fade-in[data-delay]').forEach(el => {
    const d = parseInt(el.getAttribute('data-delay'), 10);
    if (!Number.isNaN(d)) {
      el.style.transitionDelay = d + 'ms';
    }
  });

  // 画面サイズ変更時のoffset再計算
  window.addEventListener('resize', () => {
    inView.offset(0.15 * window.innerHeight);
  });